/**
 * A class that stores fetched data to prevent
 *  unecessary request. Data in the store will
 * live up to a default of 10 seconds.
 */

class Cache {
	constructor() {
		this.store = {};
	}

	set(key, value, ttl = 10000) {
		this.store[key] = value;
		setTimeout(() => {
			this.invalidate(key);
		}, ttl);
	}

	get(key) {
		const hasValue = this.store[key] !== undefined;
		return {
			hasValue,
			value: this.store[key] || null,
		};
	}

	invalidate(key) {
		delete this.store[key];
	}
}

export default Cache;
